import { api } from '../lib/api-client.js';

import type { OrgSettings, UpdateOrgSettingsInput } from '@sitewise/shared';

export async function fetchOrgSettings(): Promise<{ settings: OrgSettings }> {
  return api('/org/settings');
}

export async function patchOrgSettings(input: UpdateOrgSettingsInput) {
  return api<{ settings: OrgSettings }>('/org/settings', { method: 'PATCH', body: input });
}
